import React from 'react';
import { Shield, Zap, Users, HardDrive, Lock, Cloud } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardDescription } from './ui/card';

const Features = () => {
  const features = [
    {
      icon: Shield,
      title: '128-bit Encryption',
      description: 'Your data is protected with industry-standard encryption both in transit and at rest.'
    },
    {
      icon: Zap,
      title: 'Lightning Fast Sync',
      description: 'Access your files instantly across all your devices with real-time synchronization.'
    },
    {
      icon: Users,
      title: 'Secure Sharing',
      description: 'Share files with control - set expiration dates, passwords, and access permissions.'
    },
    {
      icon: HardDrive,
      title: 'Instant Storage Expansion',
      description: 'Expand your phone storage to terabytes in minutes with our app extension.'
    },
    {
      icon: Lock,
      title: 'Two-Factor Authentication',
      description: 'Add an extra layer of security with 2FA protection for your account.'
    },
    {
      icon: Cloud,
      title: 'Automatic Backup',
      description: 'Never lose your data with automatic backup and version history.'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Everything You Need, <span className="text-[#40E095]">Secure & Simple</span>
          </h2>
          <p className="text-lg text-gray-600">
            Built with enterprise-grade security and designed for everyday simplicity
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <Card 
                key={index}
                className="group border-2 border-gray-100 hover:border-[#40E095]/50 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 bg-white"
              >
                <CardHeader className="space-y-4">
                  <div className="bg-[#40E095]/10 group-hover:bg-[#40E095] w-14 h-14 rounded-xl flex items-center justify-center transition-all duration-300">
                    <IconComponent className="text-[#40E095] group-hover:text-white transition-colors" size={28} />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-[#40E095] transition-colors">
                    {feature.title}
                  </CardTitle>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>

        {/* Feature Image */}
        <div className="mt-16 relative">
          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://images.unsplash.com/photo-1760520338238-4137dd2dc28f" 
              alt="Cross-platform sync" 
              className="w-full h-auto"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/30 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
